import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";
import SuspensePageLoading from "../../../components/SuspensePageLoading";
import { links } from "./links";
import Requests from "../../../pages/Requests";


const Dashboard = lazy(() => import("../../../pages/Dashboard/Influencer"));
const Profile = lazy(() => import("../../../pages/Profile/Influencer"));
const UploadContent = lazy(() => import("../../../pages/UploadContent"));
const Deliverables = lazy(() => import("../../../pages/Deliverables"));


const InfluencerRoutes = () => {
    
  return (
    <>
      <Sidebar links={links} />
        <Suspense fallback={<SuspensePageLoading />}>
          <Routes>
            
            <Route path="/" element={<Dashboard />} />
            {/* <Route path="/discovery" element={<Discovery />} />
            <Route path="/campaign" element={<Campaign />} />
            <Route path="/campaign/:id" element={<CampaignDetail />} />
            <Route path="/campaign/:id/deliverable/:deliverableId" element={<DeliverableDetail/>} />
            <Route path="/campaign/create" element={<CreateCampaign />} />
            <Route path="/influencer/:id" element={<InfluencerDetail />} />
            <Route path="/influencers" element={<Influencers />} /> */}
            <Route path="/profile" element={<Profile />} />
            <Route path="/deliverable/:id" element={<UploadContent />} />
            <Route path="/deliverables" element={<Deliverables />} />
            <Route path="/requests" element={<Requests />} />



            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Suspense>
    </>
  );
};

export default InfluencerRoutes;
